<template>
  <div class="home">
    <section class="hero-section">
      <div class="hero-content">
        <h1>Investasi Rukost Premium: Raih Potensi <i>Passive Income</i> 81 Juta/Tahun di Kawasan IPB</h1>
        <p>Peluang emas di kawasan edukasi dengan yield sewa mencapai 8%. Unit eksklusif, <i>fully furnished</i>, dan dikelola secara profesional oleh Seruma.</p>
        <a href="https://wa.me/6281234567890?text=Halo, saya tertarik dengan investasi di Paradisa Studenté." target="_blank" class="cta-button">
          Konsultasi Investasi via WhatsApp
        </a>
      </div>
    </section>

    <KeyAdvantages />

    <CredibilityBlock />

    <LocationSection />
    
  </div>
</template>

<script>
// Impor komponen
import KeyAdvantages from '@/components/KeyAdvantages.vue';
import CredibilityBlock from '@/components/CredibilityBlock.vue';
import LocationSection from '@/components/LocationSection.vue';

export default {
  name: 'HomeView',
  components: {
    KeyAdvantages,
    CredibilityBlock,
    LocationSection
  }
};
</script>

<style scoped>
.hero-section {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 80vh;
  min-height: 500px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://firebasestorage.googleapis.com/v0/b/paradisa-project.firebasestorage.app/o/web_assets%2Fhero.jpg?alt=media&token=bae2b101-aeb4-40e7-a59c-27bc9953fca9'); /* Ganti dengan URL gambar render Anda */
  background-size: cover;
  background-position: center;
  color: white;
  padding: 0 20px;
}

.hero-content {
  max-width: 800px;
}

.hero-content h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.2rem;
  margin-bottom: 30px;
  line-height: 1.6;
}

/* Responsiveness for mobile */
@media (max-width: 768px) {
  .hero-section {
    height: 70vh;
  }
  .hero-content h1 {
    font-size: 2rem;
  }
  .hero-content p {
    font-size: 1rem;
  }
}
</style>